// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_b8-4";
export var collapsed = "_b8-1";
export var headerBar = "_b8-0";
export var leftHeaderContent = "_b8-3";
export var subjectContainer = "_b8-2";